

export const Button = ({children}) => {
  return (
    <div>

        <button className="rounded w-64 text-xl font-black dark:text-black dark:bg-zinc-50 bg-black text-gray-50">{children}</button>
    </div>

  )
}
